import { CENTRALE_SANS_BOLD, CENTRALE_SANS_BOOK } from '@ispm/shared/constants/fonts';
import { ChartTooltipOptionsExtended } from './interfaces';

export const TOOLTIP_COLOR = '#1C2D66';
export const CROSSHAIR_COLOR = '#2B86B2';
export const GRIDLINE_COLOR = '#E9E9E9';
export const GRAY = '#AAAAAA';
export const GRAY_RGB_FORMATTED = '170, 170, 170';
export const RED = '#FA5A4B';
export const ALERT_ORANGE = '#E65800';
export const RED_RGB_FORMATTED = '250, 90, 75';
export const WHITE = '#FFFFFF';
export const BLACK = '#212121';
export const BLACK_RGB_FORMATTED = '0, 0, 0';

export const ZERO = 0.0000000000001;

export const BG_COLOR_OPACITY = 0.3;
export const HOVER_BG_COLOR_OPACITY = 0.2;

export const TOOLTIP_STYLING: ChartTooltipOptionsExtended = {
  backgroundColor: WHITE,
  titleFontColor: TOOLTIP_COLOR,
  titleFontFamily: CENTRALE_SANS_BOLD,
  bodyFontColor: TOOLTIP_COLOR,
  bodyFontFamily: CENTRALE_SANS_BOOK,
  xPadding: 12,
  yPadding: 8,
  cornerRadius: 2,
  caretSize: 6,
  caretPadding: 12,
  displayColors: false,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  shadowBlur: 3,
  shadowColor: `rgba(${BLACK_RGB_FORMATTED}, 0.35)`,
};

export const DEFAULT_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  animation: {
    duration: 0
  },
  hover: {
    animationDuration: 0
  },
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }
  }
};
